"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dollar;
function dollar(amount) {
  return Math.floor(parseInt(amount, 10) / 100);
}